import { useEffect } from "react";
import { PRODUCT_NAME } from "./club";

/** "Page · Club brand" in the tab title; screens call this once. */
export function useDocumentTitle(title: string, brand: string = PRODUCT_NAME): void {
  useEffect(() => {
    document.title = `${title} · ${brand}`;
  }, [title, brand]);
}
